import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { CredentialResponse } from 'google-one-tap'

declare var google: typeof import('google-one-tap')

@Component({
  selector: 'flo-google-auth',
  templateUrl: './google-auth-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoogleAuthButtonComponent implements AfterViewInit {
  @Input()
  isBrowser: boolean

  @Input()
  buttonText: string
  @Input()
  googleSubmitting?: boolean
  @Input()
  analyticsName: string
  @Input()
  googleClientKey: string
  @Input()
  isSignUp: boolean

  @Output()
  readonly googleClicked = new EventEmitter<Omit<CredentialResponse, 'select_by'>>()

  // TODO: emit error and log to DD
  @Output()
  readonly handleError = new EventEmitter<string>()

  @ViewChild('gbutton') gbutton: ElementRef = new ElementRef(HTMLElement)
  @ViewChild('gbuttonWrapper') gbuttonWrapper: ElementRef

  public clickGoogle = (params: Omit<CredentialResponse, 'select_by'>): void => {
    this.googleClicked.emit(params)
  }

  public showErrorMessage = new BehaviorSubject(false)

  ngAfterViewInit() {
    if (this.isBrowser) {
      try {
        google.accounts.id.initialize({
          client_id: this.googleClientKey,
          callback: this.clickGoogle
        })
        google.accounts.id.renderButton(this.gbutton.nativeElement, {
          type: 'standard',
          theme: 'outline',
          size: 'large',
          width: this.gbuttonWrapper.nativeElement?.offsetWidth ?? 350,
          shape: 'rectangular',
          text: this.isSignUp ? 'signup_with' : 'signin_with'
          // TODO: loading state @see {@link https://flocasts.atlassian.net/browse/CXP-2284}
          // click_listener: loadingGifFuction()
        })
      } catch (error) {
        this.showErrorMessage.next(true)
        this.handleError.emit(error)
      }
    }
  }
}
